import { filter, sortBy, values } from 'lodash';

export function getGroupedMenuOptions(menuOptions, groupEnum): Array<{ value?: string; label: string; type?: string }> {
  const groupedMenuOptions: Array<{ value?: string; label: string; type?: string }> = [];
  values(groupEnum).forEach(value => {
    const groupOptions = filter(menuOptions, { group: value });
    addOptionsForGroup(groupedMenuOptions, groupOptions, value);
  });

  return groupedMenuOptions;
}

function addOptionsForGroup(options, entries, header) {
  if (entries.length === 0) {
    return;
  }

  const menuEntries = sortBy(entries, ['label']);
  options.push({ label: header, type: 'HEADER' });
  menuEntries.forEach(({ value, label }) => options.push({ value, label }));
}
